import * as React from "react";
import {
  Form,
  Input,
  Select,
  Tooltip,
  Checkbox,
  Button,
  message,
  Row,
  Col,
  Spin,
} from "antd";
import "../assets/vendors/style";
import ds from "../Services/DataServices";
import { InputGroup } from "reactstrap";
import * as reducerAction from "../appRedux/actions/Auth";
import "antd/dist/antd.css";
import { checkPasswordStrength } from "../appRedux/actions";
import { BUS_SITE_LOCAL, Options } from "../constants/StoreSetting";
import CheckLoginCredentials from "./CheckLoginCredentials";
import { env } from '../env'

const { REACT_APP_BUS_FIRST_NAME, REACT_APP_BUS_SITE_APP, REACT_APP_BUS_SITE_SECOND } = env
const { Option } = Select;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      //offset: 0,
    },
    sm: {
      span: 16,
      //offset: 0,
    },
    md: {
      span: 24,
      //  offset: 0,
    },
  },
};

message.config({
  duration: 2,
  top: 24,
});
const key = "updatable";
const openMessage = () => {
  message.loading({ content: "Registering...", key, duration: 1 });
  setTimeout(() => {
    message.success({
      content: "Registered! Please check your email to verify account",
      key,
      duration: 2,
    });
  }, 1000);
};

const TS_APP_BASE_WEB_URL = REACT_APP_BUS_SITE_APP;
const TS_APP_BASE_LOCAL_URL = BUS_SITE_LOCAL;

const Registration = () => {
  const [form] = Form.useForm();
  const [storeInfo, setState] = React.useState({
    storeName: "hello",
  });
  const [isRegisteringObj, isRegisteringState] = React.useState({
    isRegistering: 0,
  });

  const [storeUrlStatus, storeUrlStatusState] = React.useState({
    storeUrlStatus: "2", //2  - (Nothing , on page load)
  });
  const [passwordStatus, setPasswordState] = React.useState("1");
  const [registerationObjects, setregisterationObjects] = React.useState([]);
  const [businessObjects, setBusinessObjects] = React.useState([
    { id: 1, label: "" },
  ]);
  const [countriesObject, setcountriesObject] = React.useState([
    { id: 1, label: "" },
  ]);
  const [currencyObject, setcurrencyObject] = React.useState([
    { id: 1, label: "" },
  ]);
  const [getIsEmailAllowed, setIsEmailAllowed] = React.useState(0); //0:Empty Email, 1:Validating ,2: Validated, 3: Not Valid
  const [isFreeTrialOn, setIsFreeTrialOn] = React.useState(false);
  const [loader, setLoader] = React.useState(true);

  React.useEffect(() => {
    const baseURL = window.location.origin;
    if (TS_APP_BASE_LOCAL_URL != baseURL && baseURL != TS_APP_BASE_WEB_URL) {
      window.location.href = TS_APP_BASE_WEB_URL + "/signup";
    }
  }, []);

  React.useEffect(() => {
    getRegistrationData();
  }, registerationObjects);
  //let storeOptions = "";
  async function getRegistrationData() {
    const getRegistrationData = ds.getRegistrationData();
    await getRegistrationData.then((response) => {
      if(response.data && response.data.data && !response.data.data.isTrialFree){
        window.location.href = "/billing/plan";
      }
      setIsFreeTrialOn(response.data.data.isTrialFree);
      setcountriesObject(response.data.data.countriesOptions);
      setcurrencyObject(response.data.data.currencyOptions);
      setBusinessObjects(response.data.data.businessOptions);
      setTimeout(() => {
        setLoader(false);        
      }, 3000);
    }).catch(e=> {
        setLoader(false);
    });
  }

  async function storeURLVerificationService() {
    //1 -Success (Url AVAILABLE)
    //0 -error (URL TAKEN)
    //2  - (Nothing , on page load)
    //3 -validatiing (Url validiting start)
    let storeJson = {
      storeURL: form.getFieldValue("storeUrl"),
    };
    storeJson = { storeURL: storeJson.storeURL.split(".")[0] };
    let storeResult = {
      data: {
        msgCode: "",
        msgDescription: "",
      },
    };
    const storeUrlVerification = ds.storeURLVerification(storeJson);
    await storeUrlVerification.then(
      (response) => (storeResult.data = response.data)
    );

    if (storeResult.data.msgCode === "URL_AVAILABLE") {
      storeUrlStatusState({ storeUrlStatus: "1" });
    } else if (storeResult.data.msgCode === "URL_NOT_AVAILABLE") {
      storeUrlStatusState({ storeUrlStatus: "0" });
    } else if (storeResult.data.msgCode === "STORE_NAME_LENGTH") {
      storeUrlStatusState({ storeUrlStatus: "5" });
    }
  }
  async function emailVerification() {
    let storeJson = { email: form.getFieldValue("email") };
    let storeResult = {
      data: {
        data: "",
        msgCode: "",
        msgDescription: "",
      },
    };
    const emailVerification = ds.emailDomainVerification(storeJson);
    await emailVerification.then(
      (response) => (storeResult.data = response.data)
    );
    if (storeResult.data.data) {
      if (storeResult.data.msgCode === "EMAIL_DOMAIN_ALLOWED") {
        setIsEmailAllowed(2);
      } else if (storeResult.data.msgCode === "EMAIL_DOMAIN_NOT_ALLOWED") {
        setIsEmailAllowed(3);
      } else {
        setIsEmailAllowed(3);
      }
    } else {
      setIsEmailAllowed(3);
    }
  }

  function sNameChange(evt: { target: { value: any } }) {
    setState({ storeName: evt.target.value });
    let sUrl = evt.target.value.replace(/[^a-zA-Z0-9]/g, "");
    form.setFieldsValue({ storeUrl: sUrl.toLowerCase() + REACT_APP_BUS_SITE_SECOND });
    storeUrlStatusState({ storeUrlStatus: "3" });
    storeURLVerificationService();
  }

  function sUrlChange(evt: { target: { value: any } }) {
    let sUrl = evt.target.value.split(".")[0];
    let reg = new RegExp("^[a-zA-Z0-9_.]*$");
    if (reg.test(sUrl)) {
      form.setFieldsValue({ storeUrl: sUrl + REACT_APP_BUS_SITE_SECOND });
      storeUrlStatusState({ storeUrlStatus: "3" });
      storeURLVerificationService();
    } else {
      storeUrlStatusState({ storeUrlStatus: "4" });
      message.error("Space & Special Characters are not allowed");
    }
  }

  function emailChange(evt: { target: { value: any } }) {
    let email = evt.target.value.split(".")[0];
    if (email != "") {
      let reg = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
      if (reg.test(email)) {
        emailVerification();
      } else {
        message.error("Please enter valid email", 3);
      }
    }
  }
  const onFinishFailed = (errorInfo: any) => {
    message.error("Failed to register, Please enter proper data");
    isRegisteringState({ isRegistering: 0 });
  };

  const onFinish = async (values: any) => {
    isRegisteringState({ isRegistering: 1 });
    //const result = reducerAction.userSignIn({ email: "osamashafqat", password: "yahoo.com" });
    if (
      storeUrlStatus.storeUrlStatus === "0" ||
      storeUrlStatus.storeUrlStatus === "4" ||
      storeUrlStatus.storeUrlStatus === "5"
    ) {
      message.error("First you need to enter valid Store URL");
    } else {
      //   isRegisteringState({ isRegistering: 0 });
      if (getIsEmailAllowed == 2) {
        let registerUser = {
          data: {
            msgCode: "",
            msgDescription: "",
          },
        };
        await ds
          .registerUser({
            businessTypeID: values.BusinessType,
            userFirstName: values.FirstName,
            userMiddleName: "",
            userLastName: values.LastName,
            nbrOfLocation: values.Locations,
            turnoverAnnual: values.TurnOver,
            agreement: values.agreement,
            emailAddress: values.email,
            password: values.password,
            contactNumber: values.phone,
            storeName: values.storName,
            storeUrl: values.storeUrl.split(".")[0],
            countryID: values.CountryID,
            currencyID: values.CurrencyID,
            userName: values.email,
          })
          .then((response) => (registerUser.data = response.data))
          .catch((e) => 
          {
           //  console.log("Catch", e)
          });

        if (registerUser.data.msgCode == "GENERAL_SUCCESS") {
          openMessage();
          setTimeout(() => {
            window.location.href = "/SignIn";
          }, 2000);
        }
        if (registerUser.data.msgCode == "GENERAL_ERROR") {
          message.error(registerUser.data.msgDescription);
        } else if (registerUser.data.msgCode == "REG_FIELD_NOT_VALID") {
          message.error(registerUser.data.msgDescription, 5);
        }
        if (registerUser.data.msgCode == "REGISTRATION_NOT_ACTIVE") {
          message.error(registerUser.data.msgDescription);
        }
      } else {
        message.error("First you need to enter valid Email");
      }
    }
  };

  function onPassChange(e: { target: { value: any } }) {
    const result = checkPasswordStrength(e.target.value);
    setPasswordState(result);
  }

  return (
    <div className="col-md-6 signup-form">
      <CheckLoginCredentials />
      {loader ? 
      <>
      <Spin
          tip={"Loading Please Wait"}
          spinning={loader}
          size='large'
           style={{marginTop: '40%', marginLeft: '40%'}}
          //   style={{ marginTop: "15%" }}
        >

        </Spin>
      </> 
      : 
      <>

      <div className="vd-hero vd-hero--transparent">
        <h1 className="mb-0">Let's get started </h1>
        {isFreeTrialOn && (
          <p> Try {REACT_APP_BUS_FIRST_NAME} free for 14 days.&nbsp; No credit card, no commitments.{" "} </p>
        )}
      </div>

      <div className="vd-form">
      <Form
        {...formItemLayout}
        form={form}
        name="register"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          prefix: "86",
        }}
        scrollToFirstError
      >
        <Row>
          <Col md={12} sm={12} xs={24} lg={12} className="p-0">
            <Form.Item
              className="ant-form-item-label-custom ant-form-margin-right"
              name="storName"
              label="Store Name"
              rules={[
                {
                  required: true,
                  message: "Please enter your store name.",
                },
              ]}
            >
              <Input
                placeholder="Business or trading name"
                onChange={sNameChange}
              />
            </Form.Item>
          </Col>
          <Col md={12} sm={12} xs={24} lg={12} className="p-0">
            <Form.Item
              className="ant-form-item-label-custom"
              name="storeUrl"
              label="Store Url"
              rules={[
                {
                  required: true,

                  message: "Please enter your store name.",
                },
              ]}
              {...{
                help: storeUrlStatus.storeUrlStatus === "4" && "Space & Special Characters are not allowed" || 
                  storeUrlStatus.storeUrlStatus === "3" && "Validating" ||
                  storeUrlStatus.storeUrlStatus === "5" && "Store name min length is 4 max Length is 32" ||
                  storeUrlStatus.storeUrlStatus === "0" && "This web address is unavailable",

                  // storeUrlStatus.storeUrlStatus === "2"
                  //   ? " "
                  //   : storeUrlStatus.storeUrlStatus === "3"
                  //   ? "Validating"
                  //   : storeUrlStatus.storeUrlStatus === "1"
                  //   ? ""
                  //   : storeUrlStatus.storeUrlStatus === "4"
                  //   ? "Space & Special Characters are not allowed"
                  //   : storeUrlStatus.storeUrlStatus === "5"
                  //   ? "Store name min length is 4 max Length is 32"
                  //   : "This web address is unavailable",
                hasFeedback: true,
                validateStatus:
                  storeUrlStatus.storeUrlStatus === "2"
                    ? ""
                    : storeUrlStatus.storeUrlStatus === "3"
                    ? "validating"
                    : storeUrlStatus.storeUrlStatus === "1"
                    ? "success"
                    : "error",
              }}
            >
              <Input
                placeholder={`yourstore${REACT_APP_BUS_SITE_SECOND}`}
                onChange={sUrlChange}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          className="ant-form-item-label-custom"
          name="email"
          label="Email"
          rules={[
            {
              type: "email",
              message: "Please enter a valid email address.",
            },
            {
              required: true,
              message: "Please enter your email address.",
            },
          ]}
          {...{
            help:
            getIsEmailAllowed === 1 && "validating" ||
            getIsEmailAllowed === 2 && "Email Valid" ||
            getIsEmailAllowed === 3 && "Email not valid",

            //   getIsEmailAllowed === 0
            //     ? ""
            //     : getIsEmailAllowed === 1
            //     ? "validating"
            //     : getIsEmailAllowed === 2
            //     ? "Email Valid"
            //     : "Email not valid",
            hasFeedback: true,
            validateStatus:
              getIsEmailAllowed === 0
                ? ""
                : getIsEmailAllowed === 1
                ? "validating"
                : getIsEmailAllowed === 2
                ? "success"
                : "error",
          }}
        >
          <Input placeholder="Your email address" onBlur={emailChange} />
        </Form.Item>

        <Form.Item
          className="ant-form-item-label-custom"
          name="password"
          label="Password"
          rules={[
            {
              required: true,
              message: "Please enter a password.",
            },
          ]}
          {...{
            help:
                passwordStatus === "2" && "Minimum length should be 8 characters" ||
                passwordStatus === "3" && "At least 1 small case character required" ||
                passwordStatus === "4" && "At least 1 upper case character required" ||
                passwordStatus === "5" && "At least 1 special character required" ||
                passwordStatus === "6" && "At least 1 numeric value" ||
                passwordStatus === "7" && "Space Not Allowed In Password",
              // passwordStatus === "1"
              //   ? " "
              //   : passwordStatus === "2"
              //   ? "Minimum length should be 8 characters"
              //   : passwordStatus === "3"
              //   ? "At least 1 small case character required"
              //   : passwordStatus === "4"
              //   ? "At least 1 upper case character required"
              //   : passwordStatus === "5"
              //   ? "At least 1 special character required"
              //   : passwordStatus == "6"
              //   ? "At least 1 numeric value"
              //   : passwordStatus == "7"
              //   ? "Space Not Allowed In Password"
              //   : "Validating",
            hasFeedback: true,
            validateStatus: passwordStatus === "1" ? "success" : "error",
          }}
        >
          <Input.Password
            placeholder="Choose a password"
            onChange={onPassChange}
            className="password-fix"
          />
        </Form.Item>
        <Row>
          <Col md={12} sm={12} xs={24} lg={12} className="p-0">
            <Form.Item
              className="ant-form-item-label-custom ant-form-margin-right"
              name="FirstName"
              label={
                <span>
                  First Name&nbsp;
                  <Tooltip title="First Name"></Tooltip>
                </span>
              }
              rules={[
                {
                  required: true,
                  message: "Please enter your full name.",
                  whitespace: true,
                },
              ]}
            >
              <Input placeholder="Your first name" />
            </Form.Item>
          </Col>
          <Col md={12} sm={12} xs={24} lg={12} className="p-0">
            <Form.Item
              className="ant-form-item-label-custom"
              name="LastName"
              label={
                <span>
                  Last Name&nbsp;
                  <Tooltip title="Last Name"></Tooltip>
                </span>
              }
              rules={[
                {
                  required: true,
                  message: "Please enter your full name.",
                  whitespace: true,
                },
              ]}
            >
              <Input placeholder="Your last name" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          className="ant-form-item-label-custom"
          name="phone"
          label="Phone Number"
          rules={[
            { required: true, message: "Please input your phone number!" },
          ]}
        >
          <Input
            style={{ width: "100%" }}
            placeholder="Contact number with area code"
          />
        </Form.Item>

        <Form.Item
          className="ant-form-item-label-custom"
          name="BusinessType"
          label="Type of Business"
          hasFeedback
          rules={[
            {
              required: true,
              message: "Please choose your retail category.",
            },
          ]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            placeholder="Choose a retail category"
          >
            {businessObjects &&
              businessObjects.map((e, key) => {
                return (
                  <option key={key} value={e.id}>
                    {e.label}
                  </option>
                );
              })}
          </Select>
        </Form.Item>

        <Form.Item
          className="ant-form-item-label-custom"
          name="Locations"
          label="Number of Locations"
          hasFeedback
          rules={[
            {
              required: true,
              message: "Please choose the number of locations you have.",
            },
          ]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            placeholder="Choose how many locations you have"
          >
            {Options.LocationOptions &&
              Options.LocationOptions.map((e, key) => {
                return (
                  <option key={key} value={e.label}>
                    {e.label}
                  </option>
                );
              })}
          </Select>
        </Form.Item>

        <Form.Item
          className="ant-form-item-label-custom"
          name="TurnOver"
          label="Estimated Annual Turnover"
          hasFeedback
          rules={[
            {
              required: true,
              message:
                "Please choose the range your annual turnover falls into.",
            },
          ]}
        >
          <Select
            placeholder="Choose an annual turn over range"
            showSearch
            optionFilterProp="children"
          >
            {Options.TurnOverOptions &&
              Options.TurnOverOptions.map((e, key) => {
                return (
                  <option key={key} value={e.label}>
                    {e.label}
                  </option>
                );
              })}
          </Select>
        </Form.Item>

        <Row>
          <Col md={12} sm={12} xs={24} lg={12} className="p-0">
            <Form.Item
              className="ant-form-item-label-custom ant-form-margin-right"
              name="CountryID"
              label="Country"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Select your country",
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                placeholder="Select Country"
              >
                {countriesObject &&
                  countriesObject.map((e, key) => {
                    return (
                      <option key={key} value={e.id}>
                        {e.label}
                      </option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>
          <Col md={12} sm={12} xs={24} lg={12} className="p-0">
            <Form.Item
              className="ant-form-item-label-custom"
              name="CurrencyID"
              label="Currency"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Select your Currency",
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                placeholder="Select Currency"
              >
                {currencyObject &&
                  currencyObject.map((e, key) => {
                    return (
                      <option key={key} value={e.id}>
                        {e.label}
                      </option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row className="d-flex align-items-center">

          <Col md={12} sm={12} xs={24} lg={12} className="p-0">
          <Form.Item
          className="ant-form-item-label-custom"
          name="agreement"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject("Should accept agreement"),
            },
          ]}
          {...tailFormItemLayout}
        >
          <Checkbox>
            I have read the <a href="">agreement</a>
          </Checkbox>
        </Form.Item>
          </Col>

          <Col md={12} sm={12} xs={24} lg={12} className="p-0">
          <Form.Item {...tailFormItemLayout}>
          {isRegisteringObj.isRegistering || !isFreeTrialOn ? (
            <Button className="w-100" type="primary" size="large" htmlType="submit" disabled>
              <span className="ant-btn-font-color"> Start free trial</span>
            </Button>
          ) : (
            <Button className="w-100" type="primary" size="large" htmlType="submit"disabled={!isFreeTrialOn} >
              <span className="ant-btn-font-color"> Start free trial</span>
            </Button>
          )}
        </Form.Item>
          </Col>

          </Row>
        
      </Form>


      </div>

      </>
      }
    </div>
  );
};

export default Registration;
